import { ConfigService } from './config.service';
import { ILogged } from '../interfaces/ILogged'
import { Injectable } from '@angular/core';
import { JwtHelperService, JwtModuleOptions } from '@auth0/angular-jwt';
import { Router } from '@angular/router'
import { SnackbarService } from './snackbar.service';
import { Subject } from 'rxjs';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class LoggedService {

  private _logged: ILogged;
  private cuit: Subject<string>;
  private subject = new Subject<ILogged>();

  constructor
    (private configService: ConfigService,
      private jwtService: JwtHelperService,
      private router: Router,
      private snackBarService: SnackbarService
    ) {


    this.subject.subscribe(logged => {
      this._logged = logged;
    });
  }

  cModulosSideNav() {

    this._logged.linksADM = [];
    this._logged.linksCuentas = [];
    this._logged.linksPedidos = [];
    this._logged.linksProductos = [];
    this._logged.linksTablas = [];
    this._logged.linksReportes = [];

    if (this.logged?.rol === 'COBRANZAS/CTAS.CTES' || this.logged?.rol === 'CREDITOS') {
      this._logged.linksCuentas.push({
        text: this.configService.etiquetas.Cuentas.Titulo,
        path: this.configService.etiquetas.Cuentas.Path,
        icon: this.configService.etiquetas.Cuentas.Icon
      })
    }

    if (this.logged?.rol !== 'OPERADOR LOGISTICA' && this.logged?.rol !== 'COEX' && this.logged?.rol !== 'DISTRIBUIDOR') {
      if (this.logged?.rol !== 'VENDEDOR') {
        this._logged.linksReportes.push({
          text: this.configService.etiquetas.ReportesPedidos.Buscador.Titulo,
          path: this.configService.etiquetas.ReportesPedidos.Buscador.Path,
          icon: this.configService.etiquetas.ReportesPedidos.Buscador.Icon
        })
      }
      this._logged.linksReportes.push({
        text: this.configService.etiquetas.ReportesPedidosDetallados.Buscador.Titulo,
        path: this.configService.etiquetas.ReportesPedidosDetallados.Buscador.Path,
        icon: this.configService.etiquetas.ReportesPedidosDetallados.Buscador.Icon
      })
      this._logged.linksPedidos.push({
        text: this.configService.etiquetas.Cotizaciones.Buscador.Titulo,
        path: this.configService.etiquetas.Cotizaciones.Buscador.Path,
        icon: this.configService.etiquetas.Cotizaciones.Buscador.Icon
      })
      this._logged.linksPedidos.push({
        text: this.configService.etiquetas.PedidosVenta.Buscador.Titulo,
        path: this.configService.etiquetas.PedidosVenta.Buscador.Path,
        icon: this.configService.etiquetas.PedidosVenta.Buscador.Icon
      })
      this._logged.linksPedidos.push({
        text: this.configService.etiquetas.PedidosVentaAnticipada.Buscador.Titulo,
        path: this.configService.etiquetas.PedidosVentaAnticipada.Buscador.Path,
        icon: this.configService.etiquetas.PedidosVentaAnticipada.Buscador.Icon
      })
      if (this.logged?.rol !== 'VENDEDOR') {
        this._logged.linksPedidos.push({
          text: this.configService.etiquetas.PedidosEspecialesPlanta.Buscador.Titulo,
          path: this.configService.etiquetas.PedidosEspecialesPlanta.Buscador.Path,
          icon: this.configService.etiquetas.PedidosEspecialesPlanta.Buscador.Icon
        })
        this._logged.linksPedidos.push({
          text: this.configService.etiquetas.PedidosEspecialesPlantaAnticipada.Titulo,
          path: this.configService.etiquetas.PedidosEspecialesPlantaAnticipada.Buscador.Path,
          icon: this.configService.etiquetas.PedidosEspecialesPlantaAnticipada.Buscador.Icon
        })
      }
      this._logged.linksPedidos.push({
        text: this.configService.etiquetas.NotasCredito.Buscador.Titulo,
        path: this.configService.etiquetas.NotasCredito.Buscador.Path,
        icon: this.configService.etiquetas.NotasCredito.Buscador.Icon
      })

    }


    switch (this.logged?.rol) {
      case 'LOGISTICA':


        this._logged.linksPedidos.push({
          text: this.configService.etiquetas.PedidosAbastecimiento.Buscador.Titulo,
          path: this.configService.etiquetas.PedidosAbastecimiento.Buscador.Path,
          icon: this.configService.etiquetas.PedidosAbastecimiento.Buscador.Icon
        })
        this._logged.linksPedidos.push({
          text: this.configService.etiquetas.TransferenciasPlanta.Buscador.Titulo,
          path: this.configService.etiquetas.TransferenciasPlanta.Buscador.Path,
          icon: this.configService.etiquetas.TransferenciasPlanta.Buscador.Icon
        })
        this._logged.linksPedidos.push({
          text: this.configService.etiquetas.TransferenciasDistribuidores.Buscador.Titulo,
          path: this.configService.etiquetas.TransferenciasDistribuidores.Buscador.Path,
          icon: this.configService.etiquetas.TransferenciasDistribuidores.Buscador.Icon
        })
        this._logged.linksProductos.push({
          text: this.configService.etiquetas.ListasPrecios.Titulo,
          path: this.configService.etiquetas.ListasPrecios.Path,
          icon: this.configService.etiquetas.ListasPrecios.Icon
        })
        this._logged.linksProductos.push({
          text: this.configService.etiquetas.Productos.Titulo,
          path: this.configService.etiquetas.Productos.Path,
          icon: this.configService.etiquetas.Productos.Icon,
        })
        this._logged.linksProductos.push({
          text: this.configService.etiquetas.Inventarios.Titulo,
          path: this.configService.etiquetas.Inventarios.Path,
          icon: this.configService.etiquetas.Inventarios.Icon
        })
        this._logged.linksProductos.push({
          text: this.configService.etiquetas.CuotasPlantas.Titulo,
          path: this.configService.etiquetas.CuotasPlantas.Path,
          icon: this.configService.etiquetas.CuotasPlantas.Icon
        })
        this._logged.linksProductos.push({
          text: this.configService.etiquetas.CuotasDistribuidores.Titulo,
          path: this.configService.etiquetas.CuotasDistribuidores.Path,
          icon: this.configService.etiquetas.CuotasDistribuidores.Icon
        })
        break;
      case 'OPERADOR LOGISTICA':

        this._logged.linksPedidos.push({
          text: this.configService.etiquetas.PedidosAbastecimiento.Buscador.Titulo,
          path: this.configService.etiquetas.PedidosAbastecimiento.Buscador.Path,
          icon: this.configService.etiquetas.PedidosAbastecimiento.Buscador.Icon
        })
        this._logged.linksPedidos.push({
          text: this.configService.etiquetas.TransferenciasPlanta.Buscador.Titulo,
          path: this.configService.etiquetas.TransferenciasPlanta.Buscador.Path,
          icon: this.configService.etiquetas.TransferenciasPlanta.Buscador.Icon
        })

        break;
      case 'CONTING LOGISTICA':
        this._logged.linksPedidos.push({
          text: this.configService.etiquetas.PedidosAbastecimiento.Buscador.Titulo,
          path: this.configService.etiquetas.PedidosAbastecimiento.Buscador.Path,
          icon: this.configService.etiquetas.PedidosAbastecimiento.Buscador.Icon
        })
        this._logged.linksPedidos.push({
          text: this.configService.etiquetas.TransferenciasPlanta.Buscador.Titulo,
          path: this.configService.etiquetas.TransferenciasPlanta.Buscador.Path,
          icon: this.configService.etiquetas.TransferenciasPlanta.Buscador.Icon
        })
        this._logged.linksPedidos.push({
          text: this.configService.etiquetas.TransferenciasDistribuidores.Buscador.Titulo,
          path: this.configService.etiquetas.TransferenciasDistribuidores.Buscador.Path,
          icon: this.configService.etiquetas.TransferenciasDistribuidores.Buscador.Icon
        })
        break;
      case 'DISTRIBUIDOR':
        this._logged.linksPedidos.push({
          text: this.configService.etiquetas.Cotizaciones.Buscador.Titulo,
          path: this.configService.etiquetas.Cotizaciones.Buscador.Path,
          icon: this.configService.etiquetas.Cotizaciones.Buscador.Icon
        })
        this._logged.linksPedidos.push({
          text: this.configService.etiquetas.PedidosVenta.Buscador.Titulo,
          path: this.configService.etiquetas.PedidosVenta.Buscador.Path,
          icon: this.configService.etiquetas.PedidosVenta.Buscador.Icon
        })
        this._logged.linksPedidos.push({
          text: this.configService.etiquetas.PedidosVentaAnticipada.Buscador.Titulo,
          path: this.configService.etiquetas.PedidosVentaAnticipada.Buscador.Path,
          icon: this.configService.etiquetas.PedidosVentaAnticipada.Buscador.Icon
        })
        this._logged.linksPedidos.push({
          text: this.configService.etiquetas.NotasCredito.Buscador.Titulo,
          path: this.configService.etiquetas.NotasCredito.Buscador.Path,
          icon: this.configService.etiquetas.NotasCredito.Buscador.Icon
        })
        this._logged.linksPedidos.push({
          text: this.configService.etiquetas.PedidosAbastecimiento.Buscador.Titulo,
          path: this.configService.etiquetas.PedidosAbastecimiento.Buscador.Path,
          icon: this.configService.etiquetas.PedidosAbastecimiento.Buscador.Icon
        })
        this._logged.linksPedidos.push({
          text: this.configService.etiquetas.TransferenciasPlanta.Buscador.Titulo,
          path: this.configService.etiquetas.TransferenciasPlanta.Buscador.Path,
          icon: this.configService.etiquetas.TransferenciasPlanta.Buscador.Icon
        })
        this._logged.linksPedidos.push({
          text: this.configService.etiquetas.TransferenciasDistribuidores.Buscador.Titulo,
          path: this.configService.etiquetas.TransferenciasDistribuidores.Buscador.Path,
          icon: this.configService.etiquetas.TransferenciasDistribuidores.Buscador.Icon
        })
        this._logged.linksProductos.push({
          text: this.configService.etiquetas.Inventarios.Titulo,
          path: this.configService.etiquetas.Inventarios.Path,
          icon: this.configService.etiquetas.Inventarios.Icon
        })
        this._logged.linksReportes.push({
          text: this.configService.etiquetas.ReportesPedidos.Buscador.Titulo,
          path: this.configService.etiquetas.ReportesPedidos.Buscador.Path,
          icon: this.configService.etiquetas.ReportesPedidos.Buscador.Icon
        })
        this._logged.linksReportes.push({
          text: this.configService.etiquetas.ReportesPedidosDetallados.Buscador.Titulo,
          path: this.configService.etiquetas.ReportesPedidosDetallados.Buscador.Path,
          icon: this.configService.etiquetas.ReportesPedidosDetallados.Buscador.Icon
        })

        break;
      case 'VENDEDOR':

        break;
      case 'COEX':
        this._logged.linksPedidos.push({
          text: this.configService.etiquetas.NotasCredito.Buscador.Titulo,
          path: this.configService.etiquetas.NotasCredito.Buscador.Path,
          icon: this.configService.etiquetas.NotasCredito.Buscador.Icon
        })
        break;
      case 'ADMVENTAS':


        this._logged.linksPedidos.push({
          text: this.configService.etiquetas.PedidosAbastecimiento.Buscador.Titulo,
          path: this.configService.etiquetas.PedidosAbastecimiento.Buscador.Path,
          icon: this.configService.etiquetas.PedidosAbastecimiento.Buscador.Icon
        })
        this._logged.linksPedidos.push({
          text: this.configService.etiquetas.TransferenciasPlanta.Buscador.Titulo,
          path: this.configService.etiquetas.TransferenciasPlanta.Buscador.Path,
          icon: this.configService.etiquetas.TransferenciasPlanta.Buscador.Icon
        })
        this._logged.linksPedidos.push({
          text: this.configService.etiquetas.TransferenciasDistribuidores.Buscador.Titulo,
          path: this.configService.etiquetas.TransferenciasDistribuidores.Buscador.Path,
          icon: this.configService.etiquetas.TransferenciasDistribuidores.Buscador.Icon
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.AutorizacionesNC.Titulo,
          path: this.configService.etiquetas.AutorizacionesNC.Path,
          icon: this.configService.etiquetas.AutorizacionesNC.Icon,
        })

        this._logged.linksTablas.push({
          text: this.configService.etiquetas.AutorizacionesDto.Titulo,
          path: this.configService.etiquetas.AutorizacionesDto.Path,
          icon: this.configService.etiquetas.AutorizacionesDto.Icon,
        })

        this._logged.linksTablas.push({
          text: this.configService.etiquetas.TerminosPago.Titulo,
          path: this.configService.etiquetas.TerminosPago.Path,
          icon: this.configService.etiquetas.TerminosPago.Icon,
        })

        this._logged.linksTablas.push({
          text: this.configService.etiquetas.TiposListasPrecios.Titulo,
          path: this.configService.etiquetas.TiposListasPrecios.Path,
          icon: this.configService.etiquetas.TiposListasPrecios.Icon,
        })

        this._logged.linksTablas.push({
          text: this.configService.etiquetas.TiposLPPorTerminoPago.Titulo,
          path: this.configService.etiquetas.TiposLPPorTerminoPago.Path,
          icon: this.configService.etiquetas.TiposLPPorTerminoPago.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.Procesos.Titulo,
          path: this.configService.etiquetas.Procesos.Path,
          icon: this.configService.etiquetas.Procesos.Icon,
        })

        this._logged.linksTablas.push({
          text: this.configService.etiquetas.TiposCambio.Titulo,
          path: this.configService.etiquetas.TiposCambio.Path,
          icon: this.configService.etiquetas.TiposCambio.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.GruposClientes.Titulo,
          path: this.configService.etiquetas.GruposClientes.Path,
          icon: this.configService.etiquetas.GruposClientes.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.Regiones.Titulo,
          path: this.configService.etiquetas.Regiones.Path,
          icon: this.configService.etiquetas.Regiones.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.Depositos.Titulo,
          path: this.configService.etiquetas.Depositos.Path,
          icon: this.configService.etiquetas.Depositos.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.UbicacionesAlmacenamientos.Titulo,
          path: this.configService.etiquetas.UbicacionesAlmacenamientos.Path,
          icon: this.configService.etiquetas.UbicacionesAlmacenamientos.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.ZonasVendedores.Titulo,
          path: this.configService.etiquetas.ZonasVendedores.Path,
          icon: this.configService.etiquetas.ZonasVendedores.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.Distribuidores.Titulo,
          path: this.configService.etiquetas.Distribuidores.Path,
          icon: this.configService.etiquetas.Distribuidores.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.Divisiones.Titulo,
          path: this.configService.etiquetas.Divisiones.Path,
          icon: "settings"
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.Campanias.Titulo,
          path: this.configService.etiquetas.Campanias.Path,
          icon: "settings"
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.Numeradores.Titulo,
          path: this.configService.etiquetas.Numeradores.Path,
          icon: "settings"
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.MotivosDevolucionNC.Titulo,
          path: this.configService.etiquetas.MotivosDevolucionNC.Path,
          icon: this.configService.etiquetas.MotivosDevolucionNC.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.ShipToDistribuidores.Titulo,
          path: this.configService.etiquetas.ShipToDistribuidores.Path,
          icon: "settings"
        })
        this._logged.linksProductos.push({
          text: this.configService.etiquetas.ListasPrecios.Titulo,
          path: this.configService.etiquetas.ListasPrecios.Path,
          icon: this.configService.etiquetas.ListasPrecios.Icon
        })
        this._logged.linksProductos.push({
          text: this.configService.etiquetas.Productos.Titulo,
          path: this.configService.etiquetas.Productos.Path,
          icon: this.configService.etiquetas.Productos.Icon,
        })
        this._logged.linksProductos.push({
          text: this.configService.etiquetas.Inventarios.Titulo,
          path: this.configService.etiquetas.Inventarios.Path,
          icon: this.configService.etiquetas.Inventarios.Icon
        })
        this._logged.linksProductos.push({
          text: this.configService.etiquetas.CuotasPlantas.Titulo,
          path: this.configService.etiquetas.CuotasPlantas.Path,
          icon: this.configService.etiquetas.CuotasPlantas.Icon
        })
        this._logged.linksProductos.push({
          text: this.configService.etiquetas.CuotasDistribuidores.Titulo,
          path: this.configService.etiquetas.CuotasDistribuidores.Path,
          icon: this.configService.etiquetas.CuotasDistribuidores.Icon
        })
        this._logged.linksCuentas.push({
          text: this.configService.etiquetas.Cuentas.Titulo,
          path: this.configService.etiquetas.Cuentas.Path,
          icon: this.configService.etiquetas.Cuentas.Icon
        })

        this._logged.linksADM.push({
          text: this.configService.etiquetas.Parametros.Titulo,
          path: this.configService.etiquetas.Parametros.Path,
          icon: "settings"
        })
        this._logged.linksADM.push({
          text: this.configService.etiquetas.ItemsParametros.Titulo,
          path: this.configService.etiquetas.ItemsParametros.Path,
          icon: "settings"
        })
        break;
      case 'ADM':


        this._logged.linksPedidos.push({
          text: this.configService.etiquetas.PedidosAbastecimiento.Buscador.Titulo,
          path: this.configService.etiquetas.PedidosAbastecimiento.Buscador.Path,
          icon: this.configService.etiquetas.PedidosAbastecimiento.Buscador.Icon
        })
        this._logged.linksPedidos.push({
          text: this.configService.etiquetas.TransferenciasPlanta.Buscador.Titulo,
          path: this.configService.etiquetas.TransferenciasPlanta.Buscador.Path,
          icon: this.configService.etiquetas.TransferenciasPlanta.Buscador.Icon
        })
        this._logged.linksPedidos.push({
          text: this.configService.etiquetas.TransferenciasDistribuidores.Buscador.Titulo,
          path: this.configService.etiquetas.TransferenciasDistribuidores.Buscador.Path,
          icon: this.configService.etiquetas.TransferenciasDistribuidores.Buscador.Icon
        })
        this._logged.linksADM.push({
          text: this.configService.etiquetas.Usuarios.Titulo,
          path: this.configService.etiquetas.Usuarios.Path,
          icon: this.configService.etiquetas.Usuarios.Icon,
        })

        this._logged.linksADM.push({
          text: this.configService.etiquetas.Parametros.Titulo,
          path: this.configService.etiquetas.Parametros.Path,
          icon: "settings"
        })
        this._logged.linksADM.push({
          text: this.configService.etiquetas.ItemsParametros.Titulo,
          path: this.configService.etiquetas.ItemsParametros.Path,
          icon: "settings"
        })

        this._logged.linksTablas.push({
          text: this.configService.etiquetas.AutorizacionesNC.Titulo,
          path: this.configService.etiquetas.AutorizacionesNC.Path,
          icon: this.configService.etiquetas.AutorizacionesNC.Icon,
        })

        this._logged.linksTablas.push({
          text: this.configService.etiquetas.AutorizacionesDto.Titulo,
          path: this.configService.etiquetas.AutorizacionesDto.Path,
          icon: this.configService.etiquetas.AutorizacionesDto.Icon,
        })

        this._logged.linksTablas.push({
          text: this.configService.etiquetas.TerminosPago.Titulo,
          path: this.configService.etiquetas.TerminosPago.Path,
          icon: this.configService.etiquetas.TerminosPago.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.TiposListasPrecios.Titulo,
          path: this.configService.etiquetas.TiposListasPrecios.Path,
          icon: this.configService.etiquetas.TiposListasPrecios.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.TiposLPPorTerminoPago.Titulo,
          path: this.configService.etiquetas.TiposLPPorTerminoPago.Path,
          icon: this.configService.etiquetas.TiposLPPorTerminoPago.Icon,
        })

        this._logged.linksTablas.push({
          text: this.configService.etiquetas.Procesos.Titulo,
          path: this.configService.etiquetas.Procesos.Path,
          icon: this.configService.etiquetas.Procesos.Icon,
        })

        this._logged.linksTablas.push({
          text: this.configService.etiquetas.TiposCambio.Titulo,
          path: this.configService.etiquetas.TiposCambio.Path,
          icon: this.configService.etiquetas.TiposCambio.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.GruposClientes.Titulo,
          path: this.configService.etiquetas.GruposClientes.Path,
          icon: this.configService.etiquetas.GruposClientes.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.Regiones.Titulo,
          path: this.configService.etiquetas.Regiones.Path,
          icon: this.configService.etiquetas.Regiones.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.Depositos.Titulo,
          path: this.configService.etiquetas.Depositos.Path,
          icon: this.configService.etiquetas.Depositos.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.UbicacionesAlmacenamientos.Titulo,
          path: this.configService.etiquetas.UbicacionesAlmacenamientos.Path,
          icon: this.configService.etiquetas.UbicacionesAlmacenamientos.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.ZonasVendedores.Titulo,
          path: this.configService.etiquetas.ZonasVendedores.Path,
          icon: this.configService.etiquetas.ZonasVendedores.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.Distribuidores.Titulo,
          path: this.configService.etiquetas.Distribuidores.Path,
          icon: this.configService.etiquetas.Distribuidores.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.Divisiones.Titulo,
          path: this.configService.etiquetas.Divisiones.Path,
          icon: "settings"
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.Campanias.Titulo,
          path: this.configService.etiquetas.Campanias.Path,
          icon: "settings"
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.Numeradores.Titulo,
          path: this.configService.etiquetas.Numeradores.Path,
          icon: "settings"
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.MotivosDevolucionNC.Titulo,
          path: this.configService.etiquetas.MotivosDevolucionNC.Path,
          icon: this.configService.etiquetas.MotivosDevolucionNC.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.ShipToDistribuidores.Titulo,
          path: this.configService.etiquetas.ShipToDistribuidores.Path,
          icon: "settings"
        })
        this._logged.linksProductos.push({
          text: this.configService.etiquetas.ListasPrecios.Titulo,
          path: this.configService.etiquetas.ListasPrecios.Path,
          icon: this.configService.etiquetas.ListasPrecios.Icon
        })
        this._logged.linksProductos.push({
          text: this.configService.etiquetas.Productos.Titulo,
          path: this.configService.etiquetas.Productos.Path,
          icon: this.configService.etiquetas.Productos.Icon
        })
        this._logged.linksProductos.push({
          text: this.configService.etiquetas.Inventarios.Titulo,
          path: this.configService.etiquetas.Inventarios.Path,
          icon: this.configService.etiquetas.Inventarios.Icon
        })
        this._logged.linksProductos.push({
          text: this.configService.etiquetas.CuotasPlantas.Titulo,
          path: this.configService.etiquetas.CuotasPlantas.Path,
          icon: this.configService.etiquetas.CuotasPlantas.Icon
        })
        this._logged.linksProductos.push({
          text: this.configService.etiquetas.CuotasDistribuidores.Titulo,
          path: this.configService.etiquetas.CuotasDistribuidores.Path,
          icon: this.configService.etiquetas.CuotasDistribuidores.Icon
        })
        this._logged.linksCuentas.push({
          text: this.configService.etiquetas.Cuentas.Titulo,
          path: this.configService.etiquetas.Cuentas.Path,
          icon: this.configService.etiquetas.Cuentas.Icon
        })


        break;
      case 'ADM LOCAL':


        this._logged.linksPedidos.push({
          text: this.configService.etiquetas.PedidosAbastecimiento.Buscador.Titulo,
          path: this.configService.etiquetas.PedidosAbastecimiento.Buscador.Path,
          icon: this.configService.etiquetas.PedidosAbastecimiento.Buscador.Icon
        })
        this._logged.linksPedidos.push({
          text: this.configService.etiquetas.TransferenciasPlanta.Buscador.Titulo,
          path: this.configService.etiquetas.TransferenciasPlanta.Buscador.Path,
          icon: this.configService.etiquetas.TransferenciasPlanta.Buscador.Icon
        })
        this._logged.linksPedidos.push({
          text: this.configService.etiquetas.TransferenciasDistribuidores.Buscador.Titulo,
          path: this.configService.etiquetas.TransferenciasDistribuidores.Buscador.Path,
          icon: this.configService.etiquetas.TransferenciasDistribuidores.Buscador.Icon
        })
        this._logged.linksADM.push({
          text: this.configService.etiquetas.Usuarios.Titulo,
          path: this.configService.etiquetas.Usuarios.Path,
          icon: this.configService.etiquetas.Usuarios.Icon,
        })

        this._logged.linksADM.push({
          text: this.configService.etiquetas.Parametros.Titulo,
          path: this.configService.etiquetas.Parametros.Path,
          icon: "settings"
        })
        this._logged.linksADM.push({
          text: this.configService.etiquetas.ItemsParametros.Titulo,
          path: this.configService.etiquetas.ItemsParametros.Path,
          icon: "settings"
        })

        this._logged.linksTablas.push({
          text: this.configService.etiquetas.AutorizacionesNC.Titulo,
          path: this.configService.etiquetas.AutorizacionesNC.Path,
          icon: this.configService.etiquetas.AutorizacionesNC.Icon,
        })

        this._logged.linksTablas.push({
          text: this.configService.etiquetas.AutorizacionesDto.Titulo,
          path: this.configService.etiquetas.AutorizacionesDto.Path,
          icon: this.configService.etiquetas.AutorizacionesDto.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.TerminosPago.Titulo,
          path: this.configService.etiquetas.TerminosPago.Path,
          icon: this.configService.etiquetas.TerminosPago.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.TiposListasPrecios.Titulo,
          path: this.configService.etiquetas.TiposListasPrecios.Path,
          icon: this.configService.etiquetas.TiposListasPrecios.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.TiposLPPorTerminoPago.Titulo,
          path: this.configService.etiquetas.TiposLPPorTerminoPago.Path,
          icon: this.configService.etiquetas.TiposLPPorTerminoPago.Icon,
        })

        this._logged.linksTablas.push({
          text: this.configService.etiquetas.Procesos.Titulo,
          path: this.configService.etiquetas.Procesos.Path,
          icon: this.configService.etiquetas.Procesos.Icon,
        })

        this._logged.linksTablas.push({
          text: this.configService.etiquetas.TiposCambio.Titulo,
          path: this.configService.etiquetas.TiposCambio.Path,
          icon: this.configService.etiquetas.TiposCambio.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.GruposClientes.Titulo,
          path: this.configService.etiquetas.GruposClientes.Path,
          icon: this.configService.etiquetas.GruposClientes.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.Regiones.Titulo,
          path: this.configService.etiquetas.Regiones.Path,
          icon: this.configService.etiquetas.Regiones.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.Depositos.Titulo,
          path: this.configService.etiquetas.Depositos.Path,
          icon: this.configService.etiquetas.Depositos.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.UbicacionesAlmacenamientos.Titulo,
          path: this.configService.etiquetas.UbicacionesAlmacenamientos.Path,
          icon: this.configService.etiquetas.UbicacionesAlmacenamientos.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.ZonasVendedores.Titulo,
          path: this.configService.etiquetas.ZonasVendedores.Path,
          icon: this.configService.etiquetas.ZonasVendedores.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.Distribuidores.Titulo,
          path: this.configService.etiquetas.Distribuidores.Path,
          icon: this.configService.etiquetas.Distribuidores.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.Divisiones.Titulo,
          path: this.configService.etiquetas.Divisiones.Path,
          icon: "settings"
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.Campanias.Titulo,
          path: this.configService.etiquetas.Campanias.Path,
          icon: "settings"
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.Numeradores.Titulo,
          path: this.configService.etiquetas.Numeradores.Path,
          icon: "settings"
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.MotivosDevolucionNC.Titulo,
          path: this.configService.etiquetas.MotivosDevolucionNC.Path,
          icon: this.configService.etiquetas.MotivosDevolucionNC.Icon,
        })
        this._logged.linksTablas.push({
          text: this.configService.etiquetas.ShipToDistribuidores.Titulo,
          path: this.configService.etiquetas.ShipToDistribuidores.Path,
          icon: "settings"
        })
        this._logged.linksProductos.push({
          text: this.configService.etiquetas.ListasPrecios.Titulo,
          path: this.configService.etiquetas.ListasPrecios.Path,
          icon: this.configService.etiquetas.ListasPrecios.Icon
        })
        this._logged.linksProductos.push({
          text: this.configService.etiquetas.Productos.Titulo,
          path: this.configService.etiquetas.Productos.Path,
          icon: this.configService.etiquetas.Productos.Icon
        })
        this._logged.linksProductos.push({
          text: this.configService.etiquetas.Inventarios.Titulo,
          path: this.configService.etiquetas.Inventarios.Path,
          icon: this.configService.etiquetas.Inventarios.Icon
        })
        this._logged.linksProductos.push({
          text: this.configService.etiquetas.CuotasPlantas.Titulo,
          path: this.configService.etiquetas.CuotasPlantas.Path,
          icon: this.configService.etiquetas.CuotasPlantas.Icon
        })
        this._logged.linksProductos.push({
          text: this.configService.etiquetas.CuotasDistribuidores.Titulo,
          path: this.configService.etiquetas.CuotasDistribuidores.Path,
          icon: this.configService.etiquetas.CuotasDistribuidores.Icon
        })
        this._logged.linksCuentas.push({
          text: this.configService.etiquetas.Cuentas.Titulo,
          path: this.configService.etiquetas.Cuentas.Path,
          icon: this.configService.etiquetas.Cuentas.Icon
        })

        break;
      default:

        break;
    }

    this._logged.linksTablas = this._logged.linksTablas.length ? this._logged.linksTablas.sort((a, b) => a.text.localeCompare(b.text)) : this._logged.linksTablas;
    this._logged.linksProductos = this._logged.linksProductos.length ? this._logged.linksProductos.sort((a, b) => a.text.localeCompare(b.text)) : this._logged.linksProductos;
    this._logged.linksCuentas = this._logged.linksCuentas.length ? this._logged.linksCuentas.sort((a, b) => a.text.localeCompare(b.text)) : this._logged.linksCuentas;

  }


  get logged() {
    return this._logged;
  }

  isInRole(rol: string) {

    if (this._logged == null) {
      return false;
    } else {
      return this._logged.rol == rol;
    }
  }


  getLogged() {
    return this.subject.asObservable();
  }

  setLogged(token: any) {
    this.subject.next(this.jwtService.decodeToken(token));
    this.cModulosSideNav();
  }

  setToken(token) {
    localStorage.setItem('PortalCS', token);
  }

  setTokenBearer(token) {
    localStorage.setItem('TokenBearer', token);
    //this.subject.next(this.jwtService.decodeToken(token));
  }

  // setToken(token) {
  //   localStorage.setItem(this.configService.sec.Key6, this.setEncrypt(token, this.configService.sec.Key3, this.configService.sec.Key1));
  // }

  public setEncrypt(value, key1, key2): string {
    let res: string = '';

    if (value) {
      var key = CryptoJS.enc.Utf8.parse(key1);
      var iv = CryptoJS.enc.Utf8.parse(key2);

      var encrypted = CryptoJS.Rabbit.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key,
        {
          keySize: 1024 / 8,
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        });
      res = encrypted.toString()
    }

    return res;
  }

  validToken() {
    const tokenp = localStorage.getItem('PortalCS');
    const helper = new JwtHelperService();

    if (tokenp) {
      const expiration = helper.getTokenExpirationDate(tokenp);
      const isExpired = helper.isTokenExpired(tokenp);
      console.log('Token expira:', expiration);
      console.log('Fecha actual:', new Date());
      console.log('¿Token expirado?', isExpired);
    }
    if (getToken()) {
      return !this.jwtService.isTokenExpired();
    } else {
      return false;
    }
  }

  login() {

    this.router.navigateByUrl('/', { skipLocationChange: true })
      .then(() => {
        localStorage.removeItem('TokenBearer');
        localStorage.removeItem('PortalCS');
        //localStorage.removeItem(this.configService.sec.Key6);

        //location.reload();
        this.cModulosSideNav()
        this.router.navigate([this.configService.etiquetas.Login.Path])
      }

      );
  }


  logOut(taglineId: number) {
    sessionStorage.clear();
    this.router.navigateByUrl(this.configService.etiquetas.Login.Path)
      .then(() => {
        localStorage.removeItem('TokenBearer');
        localStorage.removeItem('PortalCS');
        //  localStorage.removeItem(this.configService.sec.Key6);
        this.subject.next(null);
        if (typeof taglineId != 'undefined') {
          switch (taglineId) {
            case 1:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloCierreSesion, this.configService.mensajes.LoginUsuario.CierreSesion, 1, 1);
              break;
            case 2:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloSesionExpirada, this.configService.mensajes.LoginUsuario.SesionExpirada, 2, 1);
              break;
            default:
              break;
          }
        }

        //this.snackBarService.openSnackbar(this.configService.mensajes.TituloCierreSesion, this.configService.mensajes.LoginUsuario.CierreSesion);
        //location.reload();
        // this.router.navigate(['/login'])
      }

      )

  }

  // getToken(): any {
  //   return this.getEncrypt(localStorage.getItem(this.configService.sec.Key6), this.configService.sec.Key3, this.configService.sec.Key1);
  // }

  // public getEncrypt(value, key1, key2): string {
  //   let res: string = '';

  //   if (value) {
  //     var key = CryptoJS.enc.Utf8.parse(key1);
  //     var iv = CryptoJS.enc.Utf8.parse(key2);

  //     var decrypted = CryptoJS.Rabbit.decrypt(value, key, {
  //       keySize: 1024 / 8,
  //       iv: iv,
  //       mode: CryptoJS.mode.CBC,
  //       padding: CryptoJS.pad.Pkcs7
  //     });

  //     res = decrypted.toString(CryptoJS.enc.Utf8);

  //   }

  //   return res;
  // }
}

export function getToken(): string {
  return localStorage.getItem('PortalCS');
}

// export function getToken() {


//   let res: string = '';
//   const value = localStorage.getItem("1GOzcRlmWtdnEc4clyy2FS8sBcdcGzy3TsENq53FmoeHZfYIxOsV+40GueBiy9kum3IWOXnAMHRKZ4GhD7f0PF4iWmbSO8d5Q4n4ZQ==")
//   if (value) {
//     var key = CryptoJS.enc.Utf8.parse("0uEPRQwVzxDVug+qrsAOmp39wTLMu2EX7QWpg8lJVs5UC4kN29+pg8rDEiKeyGcKD8srWA==");
//     var iv = CryptoJS.enc.Utf8.parse("AdvtmEodMXFA2iwsfOL3oxq2K42CISwU97KVr3lCPsBb9yeeIYsBMsuiPoXRWPibaLKqcXba");

//     var decrypted = CryptoJS.Rabbit.decrypt(value, key, {
//       keySize: 1024 / 8,
//       iv: iv,
//       mode: CryptoJS.mode.CBC,
//       padding: CryptoJS.pad.Pkcs7
//     });

//     res = decrypted.toString(CryptoJS.enc.Utf8);

//   }

//   return res;


// }


